
define('ClearCart.EntryPoint',
	[
		'ClearCart.View'
	],
	function (
		ClearCartView
	) {
		'use strict';

		return {
			mountToApp: function mountToApp(container) {
				var layout = container.getComponent('Layout');

				if (layout) {
					layout.addChildView('Cart.Clear.View', function () {
						return new ClearCartView({ container: container });
					});
				}

			}
		};
	});
